export default __webpack_public_path__ + "static/media/aus-made-logo.9ec2e259.svg";